'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptySolutions: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.solutions')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/page-illustration.svg"
      variant="base"
    />
  )
}
